<script setup lang="ts">
import { ref, Ref } from 'vue';
import DefaultLayout from './layouts/DefaultLayout.vue';
import { odsPopupContainer, usePopup } from "omind-design-system/components/odsPopup"
import { PopupSize } from 'omind-design-system/components/odsPopup';
import { PopupPosition } from 'omind-design-system/components/odsPopup';

const version = import.meta.env.VITE_BOOTCAMP_OMIND_VERSION;

const showVersion: Ref<boolean> = ref(false);

window.onkeydown = (event: KeyboardEvent) => {
    /* if(event.ctrlKey)
        console.log(event.ctrlKey ? 'CTRL ON' : 'CTRL OFF', event.altKey ? 'ALT ON' : 'ALT OFF', event.shiftKey ? 'SHIFT ON' : 'SHIFT OFF', event.key, event.code) */
    
    if (event.ctrlKey && event.altKey && event.code === "KeyV")
        showVersion.value = !showVersion.value;
    /* if (event.ctrlKey && event.altKey && event.code === "KeyD"){
        event.preventDefault()
        usePopup(PopupDataChoice, {
            id: 'popup-data-choice',
            canClose: true,
            size: PopupSize.Medium,
            position: PopupPosition.Right,
            overflow: true
            //componentProps: popupOptions.componentProps
        })
    } */
  /* if (event.ctrlKey && event.altKey && event.key === "d" && isInDevelopmentMode())
    showDebug.value = !showDebug.value;
  if (event.ctrlKey && event.altKey && event.key === "l" && isInDevelopmentMode())
    showLocaleKeys.value = !showLocaleKeys.value; */
}

</script>

<template>
    <DefaultLayout/>
    <odsPopupContainer />
    <div class="ods-tooltip-container"></div>
    <span v-show="showVersion"
        class="app-version"
        v-text="`v${version}`"/>
</template>

<style>
.ods-tooltip-container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: 1000;
}

.app-version{
    position: fixed; 
    bottom: 0; 
    right: 0; 
    font-size: 0.7rem; 
    padding: 0.5em;
    background-color: white;
}

</style>
